<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Schulden in box 3
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De volgende schulden vallen in box 3:
                <li class="list">schulden voor consumptiedoeleinden, zoals voor een auto of een vakantie</li>
                <li class="list">negatief saldo op een bankrekening</li>
                <li class="list">schulden voor de financiering van aandelen (behalve aandelen die horen bij een
                    aanmerkelijk belang),
                    obligaties of rechten op periodieke uitkeringen
                </li>
                <li class="list">schulden voor de financiering van de tweede woning (bijvoorbeeld een vakantiehuis) of
                    overige onroerende zaken
                </li>
                <li class="list">schulden volgens de Wet studiefinanciering</li>
                <li class="list">te betalen erfbelasting</li>
                <li class="list">bedragen aan toeslagen die je moet terugbetalen</li>
                <li class="list">schenkingen op papier die je hebt verstrekt</li>
                <div class="space10"></div>

                Je geeft voor je schulden de waarde aan op 1 januari {{ this.year }}. Voor schulden geldt een drempel
                van € {{ this.drempel | number:'1.0-0' }}. Hebt je heel {{ this.year }} een fiscale partner, dan is de
                drempel € {{ this.drempel * 2 | number:'1.0-0' }}.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Aanwending lening
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij het invullen van de schulden wordt gevraagd waar de lening voor geweest is. Dit kan zijn voor een
                box 3-woning (in Nederland of het buitenland0 of ergens anders voor.
                <div class="space10"></div>
                <b>Box 3-woning en box 3-schuld</b><br/>
                Als het gaat om een lening voor een box 3-woning, dat is het uiteraard wel nodig dat er bij de vraag
                over onroerende zaken in box 3 een of meer woningen zijn ingevuld.
                <div class="space10"></div>
                <b>Box 1-woning, maar box 3-schuld</b><br/>
                Gaat het om een andere lening/schuld? Kies dan voor 'Overige schulden'. Zo valt een aflossingsvrije
                hypotheek voor de eigen woning soms niet in box 1, maar in box 3. In dat geval kies je hier voor
                'Overige schulden'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading22">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse22" aria-expanded="false" aria-controls="collapse22">
                Lening eigen woning deels in box 1 en deels in box 3
            </button>
        </h2>
        <div id="collapse22" class="accordion-collapse collapse" aria-labelledby="heading22"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij de vraag over eigenwoningschulden (box 1) kun je aangeven dat de lening voor een gedeelte in box 1
                valt. Dat kan bijvoorbeeld het geval zijn als de lening deels gebruikt is voor de aanschaf van
                consumptiegoederen. Het deel dat niet in box 1 zit, behoort dan tot het vermogen van box 3.
                <div class="space10"></div>
                Het deel dat valt in box 3 wordt, voor de stand per 1-1, automatisch vermeld bij de schulden in box 3.
                Wil je het bedrag aanpassen of verwijderen bij de schulden in box 3? Dat doe je dan bij de
                eigenwoningschulden.
                <div class="space10"></div>
                <b>Rente van deze lening</b><br/>
                De rente van een lening die deels valt in box 1 en deels in box 3, is ook deels aftrekbaar. Zorg dat je
                de bedragen aan rente en hoofdsommen (1-1 en 31-12) voor 100% invult bij de eigenwoning-vraag. Het
                programma berekent dan zelf wel deel als aftrekbare rente meegenomen moet worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Vergoeding voor waarde vermogen VvE
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij de aankoop van een appartement heeft de aankoopsom voor een deel betrekking op de vergoeding voor
                waarde van het vermogen van de Vereniging van Eigenaren (VVE). De financiering van dat deel is dan geen
                eigenwoningschuld. In de praktijk kan de splitsing worden aangehouden die voor de overdrachtsbelasting
                is gemaakt.
                <div class="space10"></div>

                Een schuld voor de financiering van de storting in het vermogen van de Vereniging van Eigenaren (VVE) of
                een betalingsachterstand is geen eigenwoningschuld. Deze schuld behoort tot de schulden in box 3.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Belastingschulden
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Nederlandse belastingschulden geef je normaal gesproken niet aan. Maar in deze gevallen kan dit wél:

                <li class="list">je hebt vóór 1 oktober {{ this.year - 1 }} een voorlopige aanslag
                    inkomstenbelasting/premie
                    volksverzekeringen aangevraagd om in {{ this.year - 1 }} je belastingschuld te betalen.
                </li>
                <li class="list">De Belastingdienst heeft deze voorlopige aanslag niet of zo laat opgelegd dat je deze
                    niet voor 1
                    januari {{ this.year }} kon betalen.
                </li>
                <div class="space10"></div>
                Het bedrag dat je aftrekt als belastingschuld mag niet hoger zijn dan het bedrag dat je volgens de
                voorlopige aanslag moet betalen. Je moet dit bedrag wel binnen de betalingstermijn van de voorlopige
                aanslag betalen.
                <div class="space10"></div>

                Nog te betalen erfbelasting mag je ook opgeven als belastingschuld.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Schuld door schenking op papier
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je een schenking gedaan op papier? Dan telt de waarde van deze schenking misschien mee bij je
                schulden in box 3.
                <div class="space10"></div>
                Een schenking op papier is alleen op papier vastgelegd. De schenker maakt dus geen geld over en het geld
                blijft ook van de schenker. De schenker heeft daardoor een schuld aan de ontvanger. De ontvanger kan het
                geld pas opeisen als de schenker overlijdt. We noemen een schenking op papier ook wel een
                schuldigerkenning uit vrijgevigheid.
                <div class="space10"></div>
                Is de schenking bedoeld om na het overlijden te worden uitgevoerd? Dan moet je de schenking in een
                notariële akte vastleggen. Is de schenking bedoeld om op een later moment te worden uitgevoerd, maar wel
                voor het overlijden? Dan is voor de inkomstenbelasting voldoende dat je de schenking vastlegt in een
                onderhandse akte.
                <div class="space10"></div>
                Voldoet de schenking aan deze voorwaarde? Dan mag je de schenking aangeven bij je schulden. De ontvanger
                moet de schenking dan aangeven als bezitting.
                <div class="space10"></div>

                <b>Welk waarde geef je aan?</b><br/>
                Je geeft de waarde aan in het economisch verkeer. Voor die waarde is het van belang of er rente is
                overeengekomen en of het moment waarop de schenking wordt uitgevoerd bekend is.
                <div class="space10"></div>
                Ben je een reële rente overeengekomen? Dan geef je de nominale waarde aan. Ben je geen of een te lagere
                rente dan de marktrente overeengekomen? Dan geef je de contante waarde aan. Ga voor de berekening van de
                contante waarde uit van het moment waarop de schenking wordt uitgevoerd.
                <div class="space10"></div>
                Wordt de schenking uitgevoerd na het overlijden? Dan moet je het moment van uitvoering van de schenking
                schatten. Ga daarbij uit van je levensverwachting.
            </div>
        </div>
    </div>

</div>


